// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-to-order-button {
  margin: 12px;
}

ion-button {
  font-family: AppFont;
  font-size: 18px;
  line-height: 135%;
  letter-spacing: 0.01em;
  text-align: center;
  text-transform: none;
  color: var(--ion-color-secondary);
  --background: var(--ion-color-tertiary);
  --border-color: var(--ion-color-secondary);
  --border-style: solid;
  --border-width: 1px;
  --border-radius: 1px;
  --box-shadow: 2px 2px 0 #000000;
  --padding-top: 12px;
  --padding-bottom: 12px;
  --padding-start: 40px;
  --padding-end: 40px;
  height: 54px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/to-order-button/to-order-button.component.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;AACD;;AACA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iCAAA;EACA,uCAAA;EACA,0CAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,+BAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;AAED","sourcesContent":[".add-to-order-button {\n\tmargin: 12px;\n}\nion-button {\n\tfont-family: AppFont;\n\tfont-size: 18px;\n\tline-height: 135%;\n\tletter-spacing: 0.01em;\n\ttext-align: center;\n\ttext-transform: none;\n\tcolor: var(--ion-color-secondary);\n\t--background: var(--ion-color-tertiary);\n\t--border-color: var(--ion-color-secondary);\n\t--border-style: solid;\n\t--border-width: 1px;\n\t--border-radius: 1px;\n\t--box-shadow: 2px 2px 0 #000000;\n\t--padding-top: 12px;\n\t--padding-bottom: 12px;\n\t--padding-start: 40px;\n\t--padding-end: 40px;\n\theight: 54px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
